import { render, staticRenderFns } from "./NoemaArea.vue?vue&type=template&id=0b7c803e&scoped=true&"
import script from "./NoemaArea.vue?vue&type=script&lang=ts&"
export * from "./NoemaArea.vue?vue&type=script&lang=ts&"
import style0 from "./NoemaArea.vue?vue&type=style&index=0&id=0b7c803e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7c803e",
  null
  
)

export default component.exports